import { styled } from "@mui/material";
import { colorPickerName } from "../../../../../../../classes.js";
const GreedyColumn = styled("div", {
  name: colorPickerName,
  slot: "GreedyColumn"
})(() => ({
  maxWidth: "100%",
  overflow: "hidden",
  position: "relative"
}));
export {
  GreedyColumn
};
//# sourceMappingURL=GreedyColumn.js.map
